import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";

// // Original work from:
// https://github.com/russellgoldenberg/enter-view
const EnterViewOptions = {
  selector: "",
  enter: () => {},
  exit: () => {},
  progress: () => {},
  offset: 0,
  once: false
};
class EnterView {
  constructor(options) {
    // options = Object.assign(EnterViewOptions, options);
    options = $.extend(EnterViewOptions, options);

    this.raf = null;
    this.ticking = false;
    this.elements = [];
    this.height = 0;
    // this is where the stuff begins
    this.init(options);
  }

  init(options) {
    if (!options.selector) {
      return false;
    }
    
    this.setupElements(options);
    
    if (!this.elements || !this.elements.length) {
      return false;
    }
    
    this.setupRaf();
    this.setupEvents(options);
    this.updateScroll();
  }

  setupRaf() {
    this.raf = (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame || function(callback,element) { return setTimeout(callback, 1000 / 60); }).bind(window);
  }

  getOffsetHeight() {
    if (this.offset && typeof this.offset === 'number') {
      const fraction = Math.min(Math.max(0, this.offset), 1);
      return this.height - this.fraction * this.height;
    }
    return this.height;
  }

  updateHeight() {
    const cH = document.documentElement.clientHeight;
    const wH = window.innerHeight || 0;
    this.height = Math.max(cH, wH);
  }

  updateScroll() {
    this.ticking = false;
    const targetFromTop = this.getOffsetHeight();
    let self = this;

    this.elements = this.elements.filter( (el) => {
      const { top, bottom, height } = el.getBoundingClientRect();
      const entered = top < targetFromTop;
      const exited = bottom < targetFromTop;

      // enter + exit
      if (entered && !el.__ev_entered) {
        self.enter(el);
        el.__ev_progress = 0;
        self.progress(el, el.__ev_progress);
        if (this.once) return false;
      } else if (!entered && el.__ev_entered) {
        el.__ev_progress = 0;
        self.progress(el, el.__ev_progress);
        self.exit(el);
      }

      // progress
      if (entered && !exited) {
        const delta = (targetFromTop - top) / height;
        el.__ev_progress = Math.min(1, Math.max(0, delta));
        self.progress(el, el.__ev_progress);
      }

      if (entered && exited && el.__ev_progress !== 1) {
        el.__ev_progress = 1;
        self.progress(el, el.__ev_progress);
      }

      el.__ev_entered = entered;
      return true;
    });

    if (!this.elements.length) {
      window.removeEventListener('scroll', this.onScroll, true);
    }
  }

  onScroll() {
    if (!this.ticking) {
      this.ticking = true;
      this.raf(this.updateScroll.bind(this));
    }
  }

  onResize() {
    this.updateHeight();
    this.updateScroll();
  }

  onLoad() {
    this.updateHeight();
    this.updateScroll();
  }

  selectionToArray(selection) {
    const result = [];
    for (let i = 0, iL = selection.length; i < iL; i ++) {
      result.push(selection[i]);
    }
    return result;
  }

  selectAll(selector, parent = document) {
    if (typeof selector === 'string') {
      return this.selectionToArray(parent.querySelectorAll(selector));
    } else if (selector instanceof NodeList) {
      return this.selectionToArray(selector);
    } else if (selector instanceof Array) {
      return selector;
    }
  }

  setupElements(options) {
    this.elements = this.selectAll(options.selector);
  }

  setupEvents(options) {
    this.enter = options.enter;
    this.exit = options.exit;
    this.progress = options.progress;

    window.addEventListener('resize', this.onResize.bind(this), true);
    window.addEventListener('scroll', this.onScroll.bind(this), true);
    window.addEventListener('load', this.onLoad.bind(this), true);
    this.onResize();
  }
}
export { EnterView };


// WEBPACK FOOTER //
// ./Javascript/core/classes/enter-view.js